import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "font-bold" }

import {Carousel, CarouselContent, CarouselItem} from "@/components/ui/carousel";
import {Card, CardContent} from "@/components/ui/card";
import {onMounted, ref} from "vue";
import TablesService from "@/services/tables/tables.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingRoofCarousel',
  props: {
    data: {},
    entity: {}
  },
  setup(__props: any) {

const props = __props
const roofs: any = ref([]);

onMounted(async () => {
  if (props.data) {
    for (const roof of props.data) {
      const res = await TablesService.getAttachments(props.entity, roof.id, 'photos');
      roof.attachments = res?.data;
      roofs.value.push(roof);
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Carousel), {
    class: "relative w-[70%] h-full pl-4",
    opts: {
      align: 'start',
    }
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(CarouselContent), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roofs.value, (roof) => {
            return (_openBlock(), _createBlock(_unref(CarouselItem), {
              key: roof.id,
              class: "md:basis-1/2 lg:basis-1/3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "p-1 cursor-pointer min-w-lg",
                  onClick: _withModifiers(($event: any) => (_ctx.$router.push({ name: 'viewRoof', params: { id: roof.id } })), ["prevent"])
                }, [
                  _createVNode(_unref(Card), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CardContent), { class: "flex aspect-square items-center justify-center p-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: `data:${roof.attachments[0]?.mimeType};base64, ${roof.attachments[0]?.data}`,
                            alt: roof.attachments[0]?.filename,
                            class: "h-[100%] w-[100%] object-cover rounded-lg"
                          }, null, 8, _hoisted_2)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("p", _hoisted_3, _toDisplayString(roof.name), 1)
                ], 8, _hoisted_1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})